// Sugestões de busca enquanto a pessoa digita (dados de includes/busca-unificada.php).
//
// - "Buscar seu imóvel" (mobile, .js-busca-unificada): bairros, cidades, tipos e códigos;
//   escolher uma sugestão vai direto ao resultado. Enter sem escolher envia ?q=, que o
//   servidor interpreta.
// - "Bairro ou cidade" (header desktop e hero da home, .js-sugestao-local): só bairros e
//   cidades; escolher preenche o campo, para a pessoa completar os outros filtros.

const ORDEM_TIPOS = { Filtro: 0, Cidade: 1, Bairro: 2, Tipo: 3, 'Código': 4 };
const MAXIMO = 8;

let sugestoes = null;
let carregando = null;

function normalizar(texto) {
    return String(texto).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}

function carregarSugestoes() {
    if (sugestoes) {
        return Promise.resolve(sugestoes);
    }
    if (!carregando && window.nucleoImob) {
        carregando = fetch(`${window.nucleoImob.ajaxurl}?action=ni-sugestoes-busca`)
            .then((resposta) => resposta.json())
            .then((json) => {
                sugestoes = (json.data || []).map((item) => ({ ...item, busca: normalizar(item.n) }));
                return sugestoes;
            })
            .catch(() => {
                carregando = null;
                return [];
            });
    }
    return carregando || Promise.resolve([]);
}

// Começa com o termo (0) > alguma palavra começa com o termo (1) > contém o termo (2).
function pontuar(item, termo) {
    if (item.busca.startsWith(termo)) {
        return 0;
    }
    if (item.busca.split(/\s+/).some((palavra) => palavra.startsWith(termo))) {
        return 1;
    }
    return item.busca.includes(termo) ? 2 : -1;
}

function filtrar(lista, texto, tiposPermitidos) {
    const termo = normalizar(texto);
    if (termo.length < 2 && !/\d/.test(termo)) {
        return [];
    }
    const temDigito = /\d/.test(termo);
    const encontrados = [];
    lista.forEach((item) => {
        if (!tiposPermitidos.includes(item.t)) {
            return;
        }
        // Códigos só entram quando o texto tem número (evita poluir buscas por nome).
        if (item.t === 'Código' && !temDigito) {
            return;
        }
        const pontos = pontuar(item, termo);
        if (pontos >= 0) {
            encontrados.push({ item, pontos });
        }
    });
    encontrados.sort((a, b) => a.pontos - b.pontos || ORDEM_TIPOS[a.item.t] - ORDEM_TIPOS[b.item.t] || a.item.n.localeCompare(b.item.n));
    return encontrados.slice(0, MAXIMO).map((e) => e.item);
}

// Campo ainda vazio: atalhos (ex.: Lançamentos, se o campo aceitar) e as cidades e os
// bairros com mais imóveis.
function populares(lista, tipos) {
    const porQuantidade = (a, b) => (b.c || 0) - (a.c || 0);
    const atalhos = tipos.includes('Filtro') ? lista.filter((item) => item.t === 'Filtro') : [];
    const cidades = lista.filter((item) => item.t === 'Cidade').sort(porQuantidade).slice(0, 3);
    const bairros = lista.filter((item) => item.t === 'Bairro').sort(porQuantidade);
    return atalhos.concat(cidades, bairros).slice(0, MAXIMO);
}

/**
 * Liga as sugestões a um campo.
 * opcoes.tipos: tipos de sugestão aceitos; opcoes.escolher(item): o que fazer ao escolher;
 * opcoes.iniciais: mostra os locais mais procurados antes de a pessoa digitar;
 * opcoes.limite: elemento cujo fim a lista não ultrapassa (ex.: o hero da home).
 */
function iniciarCampo(campo, lista, opcoes) {
    let resultados = [];
    let ativo = -1;

    campo.setAttribute('role', 'combobox');
    campo.setAttribute('aria-autocomplete', 'list');
    campo.setAttribute('aria-expanded', 'false');

    function fechar() {
        lista.hidden = true;
        campo.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('sugestoes-abertas');
        ativo = -1;
    }

    // A lista vai só até o fim da área visível (descontando o teclado do celular) e, se houver
    // limite, até o fim dele; o resto rola por dentro, para o último item sempre ser alcançável.
    function ajustarAltura() {
        if (lista.hidden) {
            return;
        }
        const tela = window.visualViewport;
        let fim = tela ? tela.offsetTop + tela.height : window.innerHeight;
        if (opcoes.limite) {
            fim = Math.min(fim, opcoes.limite.getBoundingClientRect().bottom);
        }
        const espaco = fim - lista.getBoundingClientRect().top - 12;
        lista.style.maxHeight = `${Math.max(120, Math.round(espaco))}px`;
    }
    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', ajustarAltura);
        window.visualViewport.addEventListener('scroll', ajustarAltura);
    }
    window.addEventListener('scroll', ajustarAltura, { passive: true });
    window.addEventListener('resize', ajustarAltura);

    function destacar(indice) {
        lista.querySelectorAll('li').forEach((li, i) => li.classList.toggle('is-ativo', i === indice));
        ativo = indice;
    }

    function escolher(item) {
        fechar();
        opcoes.escolher(item);
    }

    function renderizar() {
        carregarSugestoes().then((todas) => {
            const vazio = !campo.value.trim();
            resultados = vazio && opcoes.iniciais ? populares(todas, opcoes.tipos) : filtrar(todas, campo.value, opcoes.tipos);
            lista.classList.toggle('sugestoes-busca--iniciais', vazio);
            lista.innerHTML = '';
            if (!resultados.length) {
                fechar();
                return;
            }
            resultados.forEach((item, i) => {
                const li = document.createElement('li');
                li.setAttribute('role', 'option');
                li.dataset.indice = i;
                const nome = document.createElement('span');
                nome.className = 'sugestoes-busca__nome';
                nome.textContent = item.t === 'Código' ? 'Imóvel ' + item.n : item.n;
                const detalhe = document.createElement('small');
                detalhe.textContent = item.d ? item.t + ' · ' + item.d : item.t;
                li.append(nome, detalhe);
                lista.appendChild(li);
            });
            lista.hidden = false;
            document.body.classList.add('sugestoes-abertas');
            lista.scrollTop = 0;
            campo.setAttribute('aria-expanded', 'true');
            ativo = -1;
            ajustarAltura();
        });
    }

    campo.addEventListener('focus', carregarSugestoes, { once: true });
    if (opcoes.iniciais) {
        // Ao tocar no campo vazio (também depois de fechar a lista com Esc).
        ['focus', 'click'].forEach((evento) => campo.addEventListener(evento, () => {
            if (!campo.value.trim() && lista.hidden) {
                renderizar();
            }
        }));
    }
    campo.addEventListener('input', renderizar);
    campo.addEventListener('keydown', (e) => {
        if (lista.hidden) {
            return;
        }
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            destacar(Math.min(ativo + 1, resultados.length - 1));
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            destacar(Math.max(ativo - 1, 0));
        } else if (e.key === 'Enter' && ativo >= 0) {
            e.preventDefault();
            escolher(resultados[ativo]);
        } else if (e.key === 'Escape') {
            fechar();
        }
    });
    campo.addEventListener('blur', () => window.setTimeout(fechar, 150));

    lista.addEventListener('mousedown', (e) => {
        const li = e.target.closest('li');
        if (li) {
            e.preventDefault();
            escolher(resultados[Number(li.dataset.indice)]);
        }
    });
}

function urlDaSugestao(form, item) {
    if (item.p === 'codigo') {
        return form.dataset.imovelUrl + encodeURIComponent(item.s) + '/';
    }
    const url = new URL(form.action);
    url.searchParams.set(item.p, item.s);
    return url.toString();
}

export default {
    init() {
        // Mobile: busca única que leva direto ao resultado.
        document.querySelectorAll('.js-busca-unificada').forEach((form) => {
            const campo = form.querySelector('input[name="q"]');
            iniciarCampo(campo, form.querySelector('[role="listbox"]'), {
                tipos: ['Filtro', 'Cidade', 'Bairro', 'Tipo', 'Código'],
                iniciais: true,
                escolher: (item) => {
                    window.location.href = urlDaSugestao(form, item);
                },
            });
            // Na listagem o campo mostra os filtros ativos ("Casa, Manaíra, 3+ quartos").
            const filtrosAtivos = form.dataset.filtrosAtivos || '';
            const limpar = form.querySelector('.js-busca-limpar');

            function atualizarLimpar() {
                const preenchido = campo.value.trim() !== '';
                form.classList.toggle('is-preenchido', preenchido);
                if (limpar) {
                    limpar.hidden = !preenchido;
                }
            }

            campo.addEventListener('input', atualizarLimpar);
            // Tocar no resumo dos filtros seleciona o texto: digitar começa uma busca nova.
            campo.addEventListener('focus', () => {
                if (filtrosAtivos && campo.value === filtrosAtivos) {
                    campo.select();
                }
            });

            if (limpar) {
                limpar.addEventListener('click', (e) => {
                    // Mostrando os filtros aplicados: segue o link (listagem sem filtros).
                    if (filtrosAtivos && campo.value === filtrosAtivos) {
                        return;
                    }
                    // Texto digitado: apaga e volta ao resumo dos filtros (ou ao campo vazio).
                    e.preventDefault();
                    campo.value = filtrosAtivos;
                    campo.dispatchEvent(new Event('input', { bubbles: true }));
                    if (!filtrosAtivos) {
                        campo.focus();
                    }
                });
            }

            form.addEventListener('submit', (e) => {
                const texto = campo.value.trim();
                if (!texto || (filtrosAtivos && texto === filtrosAtivos)) {
                    // Vazio: listagem completa. Resumo dos filtros sem alteração: continua onde está.
                    e.preventDefault();
                    if (!texto) {
                        window.location.href = form.action;
                    }
                }
            });
        });

        // Desktop e hero: campo "Bairro ou cidade" só é preenchido.
        document.querySelectorAll('.js-sugestao-local').forEach((campo) => {
            const lista = document.createElement('ul');
            lista.className = 'sugestoes-busca';
            lista.setAttribute('role', 'listbox');
            lista.hidden = true;
            campo.closest('.campo-v2').appendChild(lista);
            iniciarCampo(campo, lista, {
                tipos: ['Cidade', 'Bairro'],
                iniciais: campo.hasAttribute('data-sugestoes-iniciais'),
                // Na home a lista fica dentro do hero, sem invadir a seção seguinte.
                limite: campo.closest('.home-hero'),
                escolher: (item) => {
                    campo.value = item.t === 'Bairro' && item.d ? item.n + ', ' + item.d : item.n;
                },
            });
        });
    },
};
